import { SbBlokData } from "@storyblok/js";
import { useTranslate } from "@made-people/grease-translations";
import { z } from "zod";
import { cloudflareImageProcessor } from "../../bootstrap/image-processor";

const MAX_LOGOS = 4;

const imageSchema = z.object({
  filename: z.string().optional(),
  alt: z.string().optional(),
});

function getImageUrl(logo: SbBlokData): string | undefined {
  if (typeof logo.filename === "string") return logo.filename;
  const parsed = imageSchema.safeParse(logo.image);
  return parsed.success ? parsed.data.filename : undefined;
}

function getImageAlt(logo: SbBlokData): string {
  if (typeof logo.alt === "string") return logo.alt;
  const parsed = imageSchema.safeParse(logo.image);
  return parsed.success ? parsed.data.alt || "" : "";
}

export const TopbarPaymentLogos = ({
  logos,
  invert = false,
}: {
  logos: SbBlokData[];
  invert?: boolean;
}) => {
  const translate = useTranslate();
  const visibleLogos = logos.slice(0, MAX_LOGOS);

  return (
    <span className="flex items-center justify-center gap-1.5 text-body-xs lg:text-body-sm whitespace-nowrap">
      <span>{translate("Topbar_Payment_Logos_Text")}</span>
      {visibleLogos.map((logo, i) => {
        const imageUrl = getImageUrl(logo);
        if (!imageUrl) return null;
        const src = cloudflareImageProcessor.process(imageUrl, { height: 32 });
        return (
          <img
            key={logo._uid || i}
            src={src}
            alt={getImageAlt(logo)}
            className={`h-3.5 w-auto lg:h-4${invert ? " brightness-0 invert" : ""}`}
          />
        );
      })}
    </span>
  );
};
